<div class="cart-row">
	<div class="thumbnail-template">
		<ng-container *ngTemplateOutlet="thumbnailTemplate"></ng-container>
	</div>
	<div class="row-details">
		<div class="header" *ngIf="showHeader">
			<div class="info">
				<div class="responsive-thumbnail-template">
					<ng-container *ngTemplateOutlet="thumbnailTemplate"></ng-container>
				</div>
				<div class="info-subgroup">
					<div
						class="name cart-item-hover mt-1 mb-1"
						*localVar="combinedGroups?.[0]?.items?.[0] as first"
						[innerHTML]="
						(first?.metadata?.listingName || first?.metadata?.packageName || group.name | getLocale: first?.locale?.listing?.name)
						| highlightMatch:highlightQuery"
						(click)="goToGroup.emit(group); $event.stopImmediatePropagation()"
					></div>

					<div class="row-info details">
						<!-- <div>
							<span class="key"
								><mat-icon inline>{{ group.type === CartItemType.VIDEO ? 'videocam' : 'collections' }}</mat-icon></span
							>
							<span class="value ml-1">{{ group.type === CartItemType.VIDEO ? 'Video' : 'Ad' }}</span>
						</div> -->
						<!-- <div *ngIf="group.parent as creativeUnitPackage">
							<span class="key">Template:</span>
							<span class="value ml-1">{{ creativeUnitPackage.name }}</span>
						</div> -->
						<div *ngFor="let meta of group.metadata">
							<span class="key">{{ meta.name }}:</span>
							<span class="value ml-1">{{ meta.value }}</span>
						</div>

						<ng-container *ngIf="group.type === CartItemType.VIDEO">
							<div class="video-item-metadata" *ngIf="group.items?.[0]?.metadata as metaData ">
								<div *ngIf="metaData.format as format">
									<span class="key" i18n="Video Story Key@@cartListGroupRowVideoStoryKey">Story:</span>
									<span class="value ml-1">{{ format }}</span>
								</div>
								<div *ngIf="metaData.focus as focus">
									<span class="key" i18n="Video Focus Key@@cartListGroupRowVideoFocusKey">Focus:</span>
									<span class="value ml-1">{{ focus }}</span>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>

			<div *ngIf="mode === 'checkout'" class="price">{{ 0 | currency : 'USD' : 'symbol' }}</div>
			<!-- TODO: add price -->
			<div class="actions" *ngIf="showGroupActions && mode === 'list'" data-testid="approveItemsMenu">
				<mat-icon
					*ngIf="actionInProgress?.group?.id != group.id"
					class="mt-1"
					(click)="$event.stopImmediatePropagation()"
					[matMenuTriggerFor]="rowMenu"
					>more_horiz</mat-icon
				>
				<mat-icon
					*ngIf="actionInProgress?.group?.id == group.id"
					class="mt-1"
					(click)="$event.stopImmediatePropagation()"
					style="opacity: 0.5"
					>more_horiz</mat-icon
				>
				<mat-menu #rowMenu="matMenu" class="review-context-menu" backdropClass="review-context-menu">
					<div
						mat-menu-item
						*ngIf="showReview && group.type !== CartItemType.VIDEO"
						class="context-menu-item"
						(click)="groupAction.emit({ action: 'approve', group })"
					>
						<mat-icon inline>done</mat-icon>
						<ng-container i18n="Group Action@@cartListGroupRowApproveAllItems">Approve All Items</ng-container>
					</div>
					<div
						mat-menu-item
						*ngIf="showReview && group.type !== CartItemType.VIDEO"
						class="context-menu-item"
						(click)="groupAction.emit({ action: 'reject', group })"
					>
						<mat-icon inline>close</mat-icon>
						<ng-container i18n="Group Action@@cartListGroupRowRejectAllItems">Reject All Items</ng-container>
					</div>
					<div mat-menu-item *ngIf="!isGuestUser" class="context-menu-item delete" (click)="emitDeletePackage(group)">
						<mat-icon inline>delete</mat-icon> <ng-container i18n="Group Action@@cartListGroupRowDelete">Delete</ng-container>
					</div>
					<!-- <button mat-menu-item>TODO: Share public link</button> -->
					<!-- <button mat-menu-item>TODO: Duplicate</button> -->
				</mat-menu>
			</div>
			<div class="actions" *ngIf="mode === 'post-checkout' && showExport">
				<button
					mat-button
					color="primary"
					*ngIf="group.type === CartItemType.VIDEO"
					(click)="$event.stopImmediatePropagation(); exportItem.emit()"
				>
					<mat-icon inline>file_open</mat-icon>
					<span i18n="Export Video Button@@cartListGroupRowExportVideoButton">Export</span>
				</button>
			</div>
		</div>

		<ng-container *ngIf="combinedGroups?.length">
			<div class="details content-list">
				<ng-container *ngFor="let group of combinedGroups">
					<ng-container *ngIf="group.parentType === 'package'">
						<app-cart-list-item-row
							*ngFor="let item of (group.items | arrayOrDefault)"
							class="item item-row"
							[item]="item"
							[mode]="mode === 'checkout' ? 'list' : mode"
							[showDelete]="showDelete"
							[showReview]="showReview"
							[useItemTranslation]="useItemTranslations"
							[highlightQuery]="highlightQuery"
							[actionInProgress]="actionInProgress"
							(goToItem)="goToItem.emit({ item: $event, group: group })"
							(deleteItem)="deleteItems.emit({ items: [$event], mode: DeleteCartItemMode.Item })"
							(itemAction)="itemAction.emit($event)"
						></app-cart-list-item-row>
					</ng-container>

					<ng-container *ngIf="group.parentType === 'group'">
						<app-cart-list-subgroup-row
							class="item"
							[group]="group"
							[mode]="mode === 'checkout' ? 'list' : mode"
							[showDelete]="showDelete"
							[showReview]="showReview"
							[showSizeCount]="showSizeCount"
							[showGroupActions]="showGroupActions"
							[useItemTranslations]="useItemTranslations"
							[highlightQuery]="highlightQuery"
							[actionInProgress]="actionInProgress"
							[forcePanelsOpen]="forcePanelsOpen"
							[isGuestUser]="isGuestUser"
							[expanded]="expandedItems[group.id]"
							(panelExpansionChange)="expandedChange.emit({ key: group.id, state: $event })"
							(goToGroup)="goToGroup.emit($event)"
							(goToItem)="goToItem.emit($event)"
							(deleteItems)="deleteItems.emit($event)"
							(deleteItem)="deleteItems.emit({ items: [$event], mode: DeleteCartItemMode.Item })"
							(groupAction)="groupAction.emit($event)"
							(itemAction)="itemAction.emit($event)"
						></app-cart-list-subgroup-row>
					</ng-container>
				</ng-container>
			</div>
		</ng-container>

		<ng-container *ngIf="showExpandableDetails">
			<mat-accordion multi="true" *ngIf="mode === 'checkout'">
				<mat-expansion-panel class="details-panel" (expandedChange)="detailsVisible = $event">
					<mat-expansion-panel-header>
						<mat-panel-title *ngIf="detailsVisible" i18n="Hide Details@@cartListGroupRowHideDetailsButton"
							>Hide Details</mat-panel-title
						>
						<mat-panel-title *ngIf="!detailsVisible" i18n="Show Details@@cartListGroupRowShowDetailsButton"
							>Show Details</mat-panel-title
						>
					</mat-expansion-panel-header>

					<div *ngIf="group.items | arrayOrDefault as items">
						<mat-tab-group animationDuration="0ms">
							<ng-container *ngIf="group.type === CartItemType.AD_UNIT">
								<mat-tab *ngFor="let item of items" [label]="item.metadata?.name" class="mt-4">
									<app-cart-list-item-row [showDelete]="showDelete" [item]="item" [mode]="mode"></app-cart-list-item-row>
								</mat-tab>
							</ng-container>

							<ng-container *ngIf="group.type === CartItemType.VIDEO">
								<mat-tab
									*ngFor="let segment of checkoutTable?.checkoutTableObject?.segments"
									[label]="segment.title"
									class="mt-4"
								>
									<div class="details-section" *localVar="segment?.voiceoverText as voiceoverText">
										<div
											class="section-title mt-3"
											i18n="Voiceover Section Title@@cartListGroupRowVoiceoverSectionTitle"
										>
											Supers and voiceover
										</div>
										<table class="details-table basic">
											<tr *ngFor="let text of voiceoverText?.textArray">
												<td class="label" *ngIf="text?.label">{{ text?.label }}</td>
												<td
													class="label"
													*ngIf="!text?.label"
													i18n="No Voiceover Table Label@@cartListGroupRowNoVoiceoverLabel"
												>
													No Voiceover
												</td>
												<td class="value"><p [innerHTML]="text?.voiceText"></p></td>
											</tr>
											<tr *ngFor="let text of voiceoverText?.superArray">
												<td class="label">Supers</td>
												<td class="value"><div [innerHTML]="text?.superText | markdown | safeHtml"></div></td>
											</tr>
										</table>
									</div>

									<div class="details-section">
										<div class="section-title mt-6" i18n="Overlay Section Title@@cartListGroupRowOverlaySectionTitle">
											Overlay
										</div>
										<table *ngFor="let overlay of segment?.overlays" class="details-table basic">
											<tr *ngFor="let text of overlay?.fields">
												<td class="label" *ngIf="text?.defaultValue">{{ text?.label }}</td>
												<td class="value"><p [innerHTML]="text?.defaultValue"></p></td>
											</tr>
											<tr *ngFor="let text of segment?.voiceoverText?.superArray">
												<td class="label" i18n="Supers Table Label@@cartListGroupRowSupersLabel">Supers</td>
												<td class="value"><div [innerHTML]="text.superText | markdown | safeHtml"></div></td>
											</tr>
										</table>
									</div>
								</mat-tab>
							</ng-container>
						</mat-tab-group>
					</div>
				</mat-expansion-panel>
			</mat-accordion>
		</ng-container>
	</div>
</div>

<ng-template #thumbnailTemplate>
	<div class="row-thumbnail" *ngIf="showThumbnail && group.thumbnailUrl">
		<img [src]="group.thumbnailUrl" [alt]="group.name" />
	</div>
</ng-template>
